<template>
<div class="docSign_list">
    <div class="docSign_content" v-if="mediatorState">
        <div class="tit">签署文书</div>
        <template v-if="workerDocumentList.length">
            <template v-for="(doc,index) in workerDocumentList">
                <el-card :key="index" class="box-card" shadow="hover">
                    <div slot="header" class="doc_list_head">
                        <span>{{booktype[doc.sign]}}</span>
                    </div>
                    <div class="doc_item">
                        <el-row :gutter="20" class="flex-center">
                            <el-col :span="8"><span class="doc_name"><i class="el-icon-document"></i> {{doc.fileName}}</span></el-col>
                            <el-col :span="12" class="flex-center">
                                <span style="width: 60px; flex-shrink: 0">签字情况：</span>
                                <div class="flex-center" style="overflow-x: auto">
                                    <template v-for="(item,index) in doc.confirmList">
                                        <el-tag v-if="item.confirmStatus" :key="index" type="success" class="el-icon-success" style="height: 44px; line-height: 18px; padding-top: 4px;">
                                            <span>{{item.userName}}</span><br><span>{{item.sendTime}}</span>
                                        </el-tag>
                                        <el-tag v-else :key="index" type="warning" class="el-icon-question">{{item.userName}}</el-tag>
                                    </template>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <el-button type="text" v-if="!isManage" @click="deletefile(doc)">删除</el-button>
                                <el-button type="text" @click="downfile(doc,false)">下载</el-button>
                                <el-button type="text" @click="preview(doc,false)">预览</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </template>
        </template>
        <template v-else>
            <el-card class="box-card" shadow="hover">
                <div class="text item">暂无文书</div>
            </el-card>
        </template>
    </div>
    <template v-else>
        <div class="docSign_content">
            <div class="tit">已签署文书</div>
            <template v-if="documentList.length">
                <template v-for="(doc,index) in documentList">
                    <el-card :key="index" class="box-card" shadow="hover">
                        <div slot="header" class="doc_list_head">
                            <span>{{booktype[doc.docType]}}</span>
                        </div>
                        <div class="doc_item">
                            <el-row :gutter="20">
                                <el-col :span="12"><span class="doc_name"><i class="el-icon-document"></i> {{doc.attachFileName}}</span></el-col>
                                <el-col :span="4" style="margin-left:400px;">
                                    <el-button type="text" @click="downfile(doc,true)">下载</el-button>
                                    <el-button type="text" @click="preview(doc,true)">预览</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                </template>
            </template>
            <template v-else>
                <el-card class="box-card" shadow="hover">
                    <div class="text item">暂无文书</div>
                </el-card>
            </template>
        </div>
        <div class="docSign_content">
            <div class="tit">未签署文书</div>
            <template v-if="documentListUnsigned.length">
                <template v-for="(doc,index) in documentListUnsigned">
                    <el-card :key="index" class="box-card" shadow="hover">
                        <div slot="header" class="doc_list_head">
                            <span>{{booktype[doc.docType]}}</span>
                        </div>
                        <div class="doc_item">
                            <el-row :gutter="20">
                                <el-col :span="12"><span class="doc_name"><i class="el-icon-document"></i> {{doc.attachFileName}}</span></el-col>
                                <el-col :span="4" style="margin-left:400px;">
                                    <!-- <el-button type="text" @click="bookSignDialogCommom(doc.docId)">签署</el-button> -->
                                    <el-button type="text" v-if="doc.docType != 'TRIAL_RECORD'" @click="showSignDialog(doc.docId)">签署</el-button>
                                    <el-button type="text" @click="downfile(doc,true)">下载</el-button>
                                    <el-button type="text" @click="preview(doc,true)">预览</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                </template>
            </template>
            <template v-else>
                <el-card class="box-card" shadow="hover">
                    <div class="text item">暂无文书</div>
                </el-card>
            </template>
        </div>
    </template>
    <div class="docSign_content" v-if="noticeList.length">
        <div class="tit">公告签署</div>
        <template v-for="(doc,index) in noticeList">
            <el-card :key="index" class="box-card" shadow="hover">
                <div slot="header" class="doc_list_head">
                    <span>公告签署{{index+1}}</span>
                </div>
                <div class="doc_item">
                    <el-row :gutter="20">
                        <el-col :span="12"><span class="doc_name">{{doc.userName}}</span></el-col>
                        <el-col style="line-height: 40px;" :span="8"><span class="doc_name">{{doc.createTime | dateFormat}}</span></el-col>
                        <el-col :span="4">
                            <!-- <template v-if="doc.curUserSign">
                                    <el-button type="text" @click="bookSignDialog(doc)">签署</el-button>
                                </template> -->
                            <el-button type="text" @click="downfileG(doc)">下载</el-button>
                            <el-button type="text" @click="previewG(doc)">预览</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
        </template>
    </div>
    <template v-if="mediatorState">
        <div v-if="!isClosed" class="docSign_foot">
            <el-button type="primary" v-if="!isManage" @click="handleSendBook">发送文书</el-button>
            <div class="docSign_foot_block">预留签字：
                <template v-for="(item,index) in confirmList">
                    <div :key="index" style="display: flex">
                        <el-tag v-if="item.status == '0'" type="success left" class="el-icon-success">{{item.userName}}</el-tag>
                        <el-tag v-else type="warning" class="el-icon-question left">{{item.userName}}</el-tag>
                        <img v-if="item.signatureFileUrl" :src="item.signatureFileUrl" mode="aspectFit" style="width: 80px; height: 32px; margin-left: 10px" />
                    </div>
                </template>
                <a class="resign" v-if="!isManage" @click="showReSignDialog">通知签署(重签)预留签名</a>
            </div>

        </div>
    </template>
    <template v-else>
        <div v-if="!isClosed" class="docSign_foot">
            <div class="docSign_foot_block">预留签字：
                <img :src="userSignImg" class="signImg" />
                <a class="resign" v-if="isReSignStatus == '1'" @click="getReSignQrCode()">去重新签字</a>
            </div>

        </div>
    </template>

    <sendDocBookDialog ref="senddocbookdialog" :wsLink="wsLink" :currentRoomId="currentRoomId" @compontCallback="documentsUpdate" @loadPage="loadPage"></sendDocBookDialog>
    <updateDocBookDialog ref="updatedocbookdialog" @compontCallback="documentsUpdate"></updateDocBookDialog>
    <el-dialog class="booksign_dialog" title="提示" :visible.sync="dialogVisibleSign" :close-on-click-modal=false top="30vh" width="400px" :before-close="handleCloseSign" center>
        <div class="booksign_content"><i class="sign-icon-warning"></i>是否确认将预留签名签署至此文件</div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleSign = false; BtnLoading = false">取 消</el-button>
            <el-button type="primary" @click="signPicSend" :loading="BtnLoading">确 定</el-button>
        </span>
        <el-dialog class="booksign_dialog" top="30vh" width="400px" title="提示" :visible.sync="noSignDialog" :close-on-click-modal=false append-to-body center>
            <div class="booksign_content"><i class="sign-icon-wrong"></i><b>预留签名未签署</b>
                <p>请您先完成实名认证及预留签名后再签署文书</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="noSignDialog = false">取 消</el-button>
                <el-button type="primary" @click="noSignDialog = false">确 定</el-button>
            </span>
        </el-dialog>
    </el-dialog>
    <el-dialog class="booksign_dialog" :modal-append-to-body='false' title="扫描二维码" :visible.sync="dialogVisibleSignCommon" :close-on-click-modal=false top="30vh" width="400px" :before-close="handleCloseSign" center>
        <div class="booksign_content"><img :src="weixincode" alt="二维码"></div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="confirmSign" :loading="BtnLoading">已经完成签名提交</el-button>
        </span>
    </el-dialog>
    <el-dialog class="booksign_dialog" title="通知签署(重签)预留签名" :visible.sync="resignDialog" width="600px" center :modal-append-to-body="false" :show-close="false">
        <el-form label-width="80px">
            <el-form-item label="发送人员">
                <el-checkbox-group v-model="reSignArr">
                    <el-checkbox v-for="(item, index) in confirmList" :key="index" :label="item.userName" name="type"></el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeReSignDialog">取 消</el-button>
            <el-button type="primary" @click="reSignAgain">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import AlertEmit from './alertEmit'
import {
    signDocAttachList,
    sendDocAttachList,
    unsignedDocList,
    signedDocList,
    clerkConfirmQrCode,
    complementSignDoc,
    getUserSingnatureList,
    clerkConfirmCos2,
    userSignAgain,
    getUserSign,
    getMeetingUserSignStatus,
    getNoticeDocList,
    delFileByMediatorApi
} from "@/api/casespace_doclist.js";
import sendDocBookDialog from "./sendDoc.vue"
import updateDocBookDialog from "./updateDoc.vue"
import {
    getStore,dateformat
} from '@/utils/utils.js'
import filedownload from '@/api/filedown.js'
import config from '@/config/config'
import {
    userButton
} from "@/common/js/buttonMixin.js"
import {isManageRole} from "../../../utils/utils";

export default {
    components: {
        sendDocBookDialog,
        updateDocBookDialog
    },
    mixins: [userButton],
    data() {
        return {
            workerDocumentList: [],
            documentList: [],
            documentListUnsigned: [],
            documentFileList: [],
            curRoomId: null,
            dialogVisibleSign: false,
            dialogVisibleSignCommon: false,
            noSignDialog: false,
            booktype: {
                "MEDIATION_BOOK": "调解书",
                "MEDIATION_RECORD": '调解笔录',
                "ARBITRATION_BOOK": '仲裁员文书',
                "SEND_RECEIPT": '送达回证',
                "TRIAL_RECORD": '庭审笔录',
                "OTHER": '其他',
            },
            checkedDocId: '',
            weixincode: '',
            BtnLoading: false,
            curUserInfo: {},
            isClosed: localStorage.getItem('CloseState') == 'true' ? true : false,
            BtnSignLoading: [],
            mediatorState: false,
            isManage: false, // 管理员角色
            //重签弹出框状态
            resignDialog: false,
            reSignArr: [],
            confirmList: [],
            userSignImg: '',
            isRealName: '',
            //是否重签 1是 0否
            isReSignStatus: '0',
            //当前需要签署的docId
            docId: '',
            wsLink: '',
            currentRoomId: '',
            noticeList: [] //公告签署列表
        }
    },
    watch: {
        '$route'() {
            // this.isClosed = this.$route.query.isClosed == 'true' ? true : false
            if (this.$route.query.activeName == 'third') {
                this.getWorkerDocBookList()
                this.getCurDocBookList()
            }
        }
    },
    filters: {
        dateFormat(time) {
            let date = new Date(time);
            return dateformat(date, 'yyyy-MM-dd hh:mm');
        }
    },
    created() {
        this.curRoomId = this.$route.query.meetingid
        // this.getCurUserInfo()
        this.getWorkerDocBookList()
        this.getCurDocBookList()
        this.getNoticeList()
    },
    mounted() {
        let loginInfouser = JSON.parse(getStore('loginInfo'));
        this.isManage = isManageRole(loginInfouser.userRoles)

        if (loginInfouser.hasOwnProperty('personType') && loginInfouser.personType == 'STAFF') {
            this.mediatorState = true
            this.getUsersSign()
        } else {
            this.getSignbyUser(loginInfouser.memberId)
            this.getMeetingUserSignStatus(loginInfouser.memberId)
        }
        let wsInfo = this.$store.getters.getWSLink
        if (wsInfo.hasOwnProperty('wsLink')) {
            this.wsLink = wsInfo.wsLink
            this.currentRoomId = wsInfo.currentRoomId
        } else {
            let currentRoomId = this.$route.query.roomid.indexOf(',') != -1 ? this.$route.query.roomid.split(',')[0] : this.$route.query.roomid
            this.$store.dispatch('initWSLink', {
                currentRoomId: currentRoomId
            }).then(res => {
                this.wsLink = res
                this.currentRoomId = currentRoomId
            })
        }

    },
    methods: {
        getCurUserInfo() {
            let userInfo = JSON.parse(getStore('loginInfo'))
            this.curUserInfo = {
                'curUserId': userInfo.memberId,
                'isRealName': userInfo.signName
            }
            this.isRealName = userInfo.signName
        },
        getWorkerDocBookList() {
            let curUserSign, needSign, needSignArray = []
            this.workerDocumentList = []
            signDocAttachList({
                "objectId": this.curRoomId,
                "objectType": "MEDIATION"
            }).then(res => {
                if (res.data.code === 1000) {
                    let resData = res.data.data
                    console.log("@@@@@@", resData)
                    // this.workerDocumentList = resData
                    res.data.data.forEach((element, index) => {
                        needSign = []
                        curUserSign = element.confirmList.find(item => {
                            return item.userId == this.curUserInfo.curUserId && !item.confirmStatus
                        });
                        needSignArray = element.confirmList.filter(item => {
                            return !item.confirmStatus
                        });
                        if (needSignArray.length) {
                            needSignArray.forEach(item => {
                                needSign.push(item.userType)
                            });
                        }
                        element['curUserSign'] = curUserSign ? true : false
                        element['needSign'] = needSign.join()
                        this.workerDocumentList.push(element)
                        this.BtnSignLoading.push(false)
                    })
                } else {
                    this.$message.error(res.data.message)
                }
                console.log('文书', this.workerDocumentList)
            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: err
                })
            })
        },
        getCurDocBookList() {
            this.documentList = []
            this.documentListUnsigned = []
            this.documentFileList = []
            let self = this,
                curUserSign
            if (!this.mediatorState) {
                signedDocList({
                    "bizId": this.curRoomId
                }).then(res => {
                    if (res.data.code === 1000) {
                        this.documentList = res.data.data.map(item => {
                            if (!item.attachFileName) {
                                let filetype = item.attachFileId.split(".")[1]
                                item.attachFileName = item.docName
                            }
                            return item
                        })
                    }
                })
                unsignedDocList({
                    "bizId": this.curRoomId
                }).then(res => {
                    if (res.data.code === 1000) {
                        this.documentListUnsigned = res.data.data.map(item => {
                            if (!item.attachFileName) {
                                let filetype = item.attachFileId.split(".")[1]
                                item.attachFileName = item.docName
                            }
                            return item
                        })
                        // res.data.data.forEach((element,index) => {
                        //     curUserSign = element.confirmList.find(item => {
                        //         return item.userId == self.curUserInfo.curUserId && !item.confirmStatus
                        //     });
                        //     element['curUserSign'] = curUserSign?true:false
                        //     self.documentListUnsigned.push(element)
                        // });
                    }
                })
            } else {
                signDocAttachList({
                    "objectId": this.curRoomId,
                    "objectType": "MEDIATION"
                }).then(res => {
                    if (res.data.code === 1000) {
                        // this.documentList = res.data.data
                        res.data.data.forEach((element, index) => {
                            curUserSign = element.confirmList.find(item => {
                                return item.userId == self.curUserInfo.curUserId && !item.confirmStatus
                            });
                            element['curUserSign'] = curUserSign ? true : false
                            self.documentList.push(element)
                        });
                    }
                })
            }
            sendDocAttachList({
                "objectId": this.curRoomId,
                "objectType": "MEDIATION"
            }).then(res => {
                if (res.data.code === 1000) {
                    self.documentFileList = res.data.data
                }
            })
        },
        getNoticeList() {
            let params = {
                bizId: this.curRoomId
            }
            this.noticeList = []
            getNoticeDocList(params).then(res => {
                console.log('res===', res)
                if (res.data.code === 1000) {
                    this.noticeList = res.data.data
                }
            }).catch(err => {
                console.log('err===', err)
            })
        },
        handleSendBook() {
            this.$refs.senddocbookdialog.openDocDialog()
            // this.$refs.updatedocbookdialog.openDocDialog()
        },
        documentsUpdate(data) {
            this.getWorkerDocBookList()
            this.getCurDocBookList()
            AlertEmit.$emit('sendBookWebSocket', data)
        },
        bookSignComplement(index, docId, type) {
            this.BtnSignLoading.splice(index, 1, true)
            complementSignDoc({
                "bizId": this.curRoomId,
                "docId": docId,
                "userType": type
            }).then(res => {
                if (res.data.code === 1000) {
                    this.$message({
                        message: '成功发送补签短信',
                        type: 'success'
                    })
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'warning'
                    })
                }
                this.BtnSignLoading.splice(index, 1, false)
            }, err => {
                this.BtnSignLoading.splice(index, 1, false)
            })
        },
        bookSignDialog(data) {
            if (this.isReSignStatus == "1") {
                this.$message.warning('仲裁员需要您重新进行签名,请先设置预留签名后再进行签署')
            } else {
                this.dialogVisibleSign = true
                this.checkedDocId = data.docId
                this.checkedObjectType = data.sign
            }
        },
        bookSignDialogCommom(id) {
            this.checkedDocId = id
            this.dialogVisibleSignCommon = true
            clerkConfirmQrCode({
                "docId": id
            }).then(res => {
                if (res.data.code === 1000) {
                    this.weixincode = res.data.data.launchSign + "/" + config.appName
                }
            })
        },
        getReSignQrCode() {
            let token = JSON.parse(localStorage.getItem('loginInfo')).token
            this.dialogVisibleSignCommon = true
            // clerkConfirmQm({jwtToken: token, meetingId: this.curRoomId}).then(res => {
            //     console.log("%%%",res)
            //      this.weixincode = res
            // })
            this.weixincode = `${config.baseURL}/gzzc/clerkOpinion/clerkConfirmQm?jwtToken=${token}&meetingId=${this.curRoomId}`
        },
        handleCloseSign(done) {
            done()
        },
        //使用预留签名签字
        signPicSend() {
            let self = this
            console.log(this.isRealName, this.userSignImg)
            if (this.isRealName && this.userSignImg) {
                this.BtnLoading = true
                clerkConfirmCos2({
                    documentIds: this.docId,
                    degree: 0,
                    objectType: "MEETING",
                    meetingId: this.curRoomId
                }).then(res => {
                    if (res.data.code === 1000) {
                        self.dialogVisibleSign = false
                        if (res.data.data.message) {
                            self.$message({
                                message: res.data.data.message,
                                type: 'warning'
                            })
                        }
                        self.getWorkerDocBookList()
                        self.getCurDocBookList()
                        self.dialogVisibleSign = false
                    } else {
                        self.$message.error(res.data.message)
                    }
                    self.BtnLoading = false
                }, err => {
                    self.$message.error(err)
                    self.BtnLoading = false
                })
            } else {
                this.noSignDialog = true
            }
        },

        confirmSign() {
            this.BtnLoading = true
            // signatureConfirmInfo({
            //     "documentIds": [this.checkedDocId]
            // }).then((res) => {
            //     if (res.data.code === 1000) {
            //         if (res.data.data) {
            //             this.dialogVisibleSignCommon = false

            //             this.getWorkerDocBookList()
            //             this.getCurDocBookList()
            //             // this.$emit('comcallback',{type:this.dialogType})
            //         } else {
            //             this.$message.error('还没有完成签名')
            //         }
            //     } else {
            //         if (res.data.message) this.$message.error(res.data.message)
            //     }
            //     this.BtnLoading = false
            // }, (error) => {
            //     this.BtnLoading = false
            //     console.log("签名出错")
            // })
            getUserSign({
                meetingId: this.curRoomId,
                userId: JSON.parse(getStore('loginInfo')).memberId
            }).then((res) => {
                console.log('res--:', res)
                this.BtnLoading = false
                this.userSignImg = res.data.data.signatureFileUrl
                this.isReSignStatus = res.data.data.status
                if (res.data.data.status == "1") {
                    this.$message.warning('您还未完成预留签名')
                    return
                } else {
                    this.dialogVisibleSignCommon = false
                }
            }).catch(error => {
                this.BtnLoading = false
            })
        },
        deletefile(doc) {
            let params = {docId : doc.docId}
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            delFileByMediatorApi(params).then(res => {
                loading.close()
                if (res.data.code === 1000) {
                    this.$message.success('已成功删除')
                    // 刷新列表
                    this.loadPage()
                } else {
                    this.$message('删除失败')
                }
                console.log(res)
            }).catch(err => {
                loading.close()
                this.$message('删除失败')
                console.log(err)
            })
            console.log(doc)
        },
        downfile(doc, type) {
            if (type) {
                filedownload('/gzzc/docBook/clerkRecordDownload', {
                    fileId: doc.attachFileId,
                    id: doc.attachId
                }, doc.attachFileName)
            } else {
                filedownload('/gzzc/docBook/clerkRecordDownload', {
                    fileId: doc.fileId,
                    id: doc.id
                }, doc.fileName)
            }
        },
        downfileG(doc) {
            let index = doc.content.lastIndexOf('.')
            let fileName = '公告签署'
            if (index >= 0) {
                let ext = doc.content.substr(index , doc.content.length - index)
                fileName += ext
            }
            filedownload('/gzzc/docBook/fileDownload', {
                fileId: doc.content,
                id: doc.id
            }, fileName)
        },
        preview(doc, type) {
            if (type) {
                window.open(config.baseURL + '/gzzc/docBook/previewImg/' + doc.attachFileId)
            } else {
                window.open(config.baseURL + '/gzzc/docBook/previewImg/' + doc.fileId)
            }
        },
        previewG(doc){
             window.open(config.baseURL + '/gzzc/docBook/previewImg/' + doc.content)
        },
        showReSignDialog() {
            this.resignDialog = true
        },
        //获取用户签名接口
        getUsersSign() {
            getUserSingnatureList({
                remark: this.curRoomId
            }).then((res) => {
                console.log('res:', res)
                if (res.data.code == 1000) {
                    this.confirmList = res.data.data
                }
            })
        },
        closeReSignDialog() {
            this.reSignArr = []
            this.resignDialog = false
        },
        //发送重新签名
        reSignAgain() {
            let ul = []
            console.log(this.reSignArr)
            if (this.reSignArr.length == 0) {
                this.$message.warning('请选择需重新签名的当事人')
                return
            } else if (this.reSignArr.length == 1) {
                ul.push(this.confirmList.filter(n => n.userName == this.reSignArr)[0].userId)
            } else {
                this.reSignArr.map(item => {
                    ul.push(this.confirmList.filter(n => n.userName == item)[0].userId)
                })
            }
            console.log(ul)
            userSignAgain({
                meetingId: this.curRoomId,
                userIdList: ul
            }).then((res) => {
                console.log('res:', res)
                if (res.data.code == 1000) {
                    this.$message.success('通知重签发送成功')
                    this.resignDialog = false
                    this.getUsersSign()
                    this.getWorkerDocBookList()
                } else {
                    this.$message.error('发送重签失败')
                }
            })
        },
        //获取用户预留签名
        getSignbyUser(userId) {
            getUserSign({
                meetingId: this.curRoomId,
                userId: userId
            }).then((res) => {
                console.log('res--:', res)
                this.userSignImg = res.data.data.signatureFileUrl
                this.isReSignStatus = res.data.data.status
            })
        },
        showSignDialog(docId) {
            if (this.isReSignStatus == "1") {
                this.$message.warning('仲裁员需要您重新进行签名,请先设置预留签名后再进行签署')
                // this.noSignDialog = true
            } else {
                this.docId = docId
                this.dialogVisibleSign = true
            }
        },
        loadPage() {
            // this.getCurUserInfo()
            this.getWorkerDocBookList()
            this.getCurDocBookList()
        },
        getMeetingUserSignStatus(userId) {
            getMeetingUserSignStatus({
                meetingId: this.curRoomId,
                userId: userId
            }).then((res) => {
                this.isRealName = res.data.data
            })
        }
    }
}
</script>

<style lang="scss">
.docSign_list {
    margin: 26px 40px 20px 65px;

    .docSign_content {
        .box-card {
            margin-bottom: 12px;
        }

        padding-bottom: 40px;

        .tit {
            font-size: 20px;
            color: #333333;
            position: relative;
            padding-left: 12px;
            margin-bottom: 30px;

            &:before {
                position: absolute;
                content: '';
                width: 4px;
                height: 20px;
                background-color: #1e6dcb;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        .el-card__header {
            padding: 10px 20px;
            background-color: #f8f9fa;

            span {
                font-size: 14px;
            }
        }

        .doc_item {
            line-height: 32px;

            .doc_name {
                font-size: 14px;
            }

            .el-tag {
                margin-right: 8px;
            }
        }
    }

    .docSign_foot {
        text-align: center;

        .el-button {
            color: #fff;
        }
    }

    .docSign_foot_block {
        width: 100%;
        height: 80px;
        margin-top: 20px;
        font-size: 16px;
        border-top: 1px solid #EBEEF5;
        display: flex;
        align-items: center;

        .left {
            margin-left: 10px;
        }

        .resign {
            margin-left: 20px;
            text-decoration: underline;
            color: #1e6dcb;
            cursor: pointer;
        }

        .signImg {
            width: 120px;
            margin-left: 10px;
        }
    }
}
.flex-center {
    display: flex;
    align-items: center;
}
.booksign_dialog {
    .booksign_content {
        text-align: center;
        font-size: 16px;

        i.sign-icon-warning {
            display: block;
            margin: 0 auto 20px;
            width: 56px;
            height: 56px;
            background: url("~@/assets/images/ico-sign_warning.png")
        }

        i.sign-icon-wrong {
            display: block;
            margin: 0 auto 20px;
            width: 56px;
            height: 56px;
            background: url("~@/assets/images/ico-sign_wrong.png")
        }
    }

    .dialog-footer {
        display: inline-block;
        padding-bottom: 20px;

        .el-button {
            min-width: 120px;
            height: 40px;
        }
    }

    .el-button+.el-button {
        margin-left: 40px;
    }
}
</style>
